import { render, staticRenderFns } from "./VAutocomplete.vue?vue&type=template&id=1a7489a6"
import script from "./VAutocomplete.vue?vue&type=script&lang=js"
export * from "./VAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./VAutocomplete.vue?vue&type=style&index=0&id=1a7489a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
